import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';

interface Params {
  clientId: string;
  isSpouse: boolean;
  hypotheticalStartAge?: number | string;
}

const estimateMonthlyPIA = (params: Params): Promise<{ EstimateMonthlyPIA: number }> => {
  return authFetch(urlWithParams('/Consumer/IncomeStep/EstimateMonthlyPIA', params));
};

export const useEstimateMonthlyPIAMutation = () => {
  return useMutation(estimateMonthlyPIA);
};
